import React, { useCallback, useState, memo } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import {
  ClientCustomCalendarModel,
  ReportCurrency,
  ReportType,
} from '../../../../models';
import { CustomDateRange } from '../custom-date-range/CustomDateRange';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import { buildDropdownList } from '../helpers/buildReportSettingData';
import { DateRangeMode } from '../date-range/DateRange';
import ReportSettingPIT from '../ReportSettingPIT';

interface ReportSettingLeaseCommitmentProps {
  onChange: (updatedValue: ReportSettingLeaseCommitmentState) => void;
  reportSettingState: ReportSettingLeaseCommitmentState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings?: ClientCustomCalendarModel;
  isAllowPIT: boolean;
}

export interface ReportSettingLeaseCommitmentState {
  selectedCurrency: SelectOption<ReportCurrency>;
  shortStartDate: string;
  shortEndDate: string;
  selectedEndDateOption: string;
  isValid: boolean;
}

function ReportDateSettingCommitment({
  onChange,
  reportSettingState,
  reportTypeSetting,
  customCalendarSettings,
  isAllowPIT,
}: ReportSettingLeaseCommitmentProps): JSX.Element {
  const endDateList = buildDropdownList(
    'Commitment',
    'EndDate',
    reportTypeSetting,
    'CustomRadio',
  );
  const [isDateRangeValid, setDateRangeValidStatus] = useState(false);
  const inputHandler = useCallback(
    (state: ReportSettingLeaseCommitmentState) => {
      const { isValid } = state;
      let isValidInput = isDateRangeValid;
      if (isValid !== undefined) {
        isValidInput = isValid;
        setDateRangeValidStatus(isValid);
      }

      onChange({
        ...state,
        isValid: isValidInput,
      });
    },
    [isDateRangeValid, onChange],
  );
  return (
    <>
      <CustomDateRange
        onChange={useCallback(
          (
            shortStartDate: string,
            shortEndDate: string,
            selectedEndDateOption: string,
            isValid: boolean,
          ): void => {
            inputHandler({
              ...reportSettingState,
              shortStartDate,
              shortEndDate,
              selectedEndDateOption,
              isValid,
            });
          },
          [inputHandler, reportSettingState],
        )}
        shortStartDate={reportSettingState.shortStartDate}
        shortEndDate={reportSettingState.shortEndDate}
        selectedEndDateOption={reportSettingState.selectedEndDateOption}
        endDateList={endDateList}
        endDateMode={DateRangeMode.FullDate}
        customCalendarPeriods={customCalendarSettings.numberOfPeriods}
      />
      <ReportSettingPIT
        reportType={ReportType.leaseCommittment}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={customCalendarSettings}
        isAllowPIT={isAllowPIT}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingLeaseCommitmentState),
          [onChange],
        )}
      />
    </>
  );
}

export default memo(ReportDateSettingCommitment);
